<template>
  <div
    :class="[
      'action-button-group',
      { 'action-button-group--compact': compact },
    ]"
  >
    <button
      :style="{ opacity: showInfo ? 1 : 0, pointerEvents: showInfo ? 'auto' : 'none' }"
      @click="$emit('info', item)"
      class="action-button"
      v-b-tooltip.hover="{ title: infoTooltip, html: true }"
      :class="{ 'action-button--disabled': disabledInfo }"
      :disabled="disabledInfo"
    >
      <i class="fas fa-info-circle icon-action icon-info-hover"></i>
    </button>
    <button
      :style="{ opacity: showEdit ? 1 : 0, pointerEvents: showEdit ? 'auto' : 'none' }"
      @click="$emit('edit', item)"
      class="action-button"
      v-b-tooltip.hover
      :title="editTooltip"
      :class="{ 'action-button--disabled': disabledEdit }"
      :disabled="disabledEdit"
    >
      <i class="fas fa-edit icon-action icon-edit-hover"></i>
    </button>
    <button
      :style="{ opacity: showDelete ? 1 : 0, pointerEvents: showDelete ? 'auto' : 'none' }"
      @click="$emit('delete', item)"
      class="action-button"
      v-b-tooltip.hover
      :title="deleteTooltip"
      :class="{ 'action-button--disabled': disabledDelete }"
      :disabled="disabledDelete"
    >
      <i class="fas fa-trash-alt icon-action icon-delete-hover"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionButtonGroup",
  props: {
    item: {
      type: Object,
      default: null,
    },
    infoTooltip: {
      type: String,
      default: "ข้อมูล",
    },
    editTooltip: {
      type: String,
      default: "แก้ไข",
    },
    deleteTooltip: {
      type: String,
      default: "ลบ",
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    disabledInfo: {
      type: Boolean,
      default: false,
    },
    disabledEdit: {
      type: Boolean,
      default: false,
    },
    disabledDelete: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.action-button-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.action-button-group--compact {
  gap: 0px;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  background-color: transparent !important;
}

.icon-action {
  font-size: 20px !important;
  cursor: pointer;
  color: #a3a4a6;
}

.icon-edit-hover:hover {
  color: #1976d2;
}

.icon-delete-hover:hover {
  color: #d33;
}

.icon-info-hover:hover {
  color: #1976d2;
}

.action-button:disabled,
.action-button--disabled {
  cursor: not-allowed !important;
  color: #ebebeb !important;
}
.action-button:disabled .icon-action,
.action-button--disabled .icon-action {
  cursor: not-allowed !important;
  color: #ebebeb !important;
}
</style>
